<template>
  <b-input-group size="sm" v-if="typeof title != 'undefined' && Array.isArray(title)">
    <template v-slot:prepend>
      <b-input-group-text><span class="d-inline d-md-none">{{ title[0] }}</span><span class="d-none d-md-inline">{{ title[1] }}</span></b-input-group-text>
    </template>
    <b-form-select :state="state" size="sm" :options="this.Enum(type, name)" :value="value" v-model="model"
                   @change="$emit('change')"></b-form-select>
  </b-input-group>

  <b-input-group size="sm" v-else-if="typeof title != 'undefined' && !Array.isArray(title)" :prepend="title">
    <b-form-select :state="state" size="sm" :options="this.Enum(type, name)" :value="value" v-model="model"
                   @change="$emit('change')"></b-form-select>
  </b-input-group>

  <b-form-select :state="state" v-else size="sm" :options="this.Enum(type, name)" :value="value" v-model="model"
                 @change="$emit('change')"></b-form-select>

</template>

<script>
export default {
  name: 'Enums',
  props: ['type', 'name', 'first', 'base', 'value', 'title', 'group', 'fields', 'org_id', 'state'],

  data: function () {
    return {
      options: [],
      enums: {
        orgtype: [
          {value: 1, text: 'Юридическое лицо',},
          {value: 2, text: 'Индивидуальный предприниматель'}
        ],
        orgmode: [
          {value: 1, text: 'Общеустановленный режим',},
          {value: 2, text: 'Упрощенный режим'},
          {value: 3, text: 'СНР: Сельхозпроизводители'}
        ],

        gender: [
          {value: 0, text: 'Выберите пол',},
          {value: 1, text: 'Мужской',},
          {value: 2, text: 'Женский'}
        ],
        invalid_group: [
          {value: 0, text: 'Не инвалид'},
          {value: 1, text: 'Инвалид I группы бессрочно'},
          {value: 2, text: 'Инвалид II группы бессрочно'},
          {value: 21, text: 'Инвалид I группы с ограниченным сроком'},
          {value: 22, text: 'Инвалид II группы с ограниченным сроком'},
          {value: 3, text: 'Инвалид III группы'},
          {value: 11, text: 'Родитель (опекун) инвалида I группы'},
          {value: 12, text: 'Родитель (опекун) инвалида II группы'},
          {value: 13, text: 'Родитель (опекун) инвалида III группы'}
        ],
        ecology: [
          {value: '', text: 'Нет экологических надбавок'},
          {value: '2', text: 'Зона чрезвычайного радиационного риска - 2 МРП'},
          {value: '1.75', text: 'Зона максимального радиационного риска - 1.75 МРП'},
          {value: '1.5', text: 'Зона повышенного радиационного риска - 1.5 МРП'},
          {value: '1.25', text: 'Зона минимального радиационного риска - 1.25 МРП'},
          {value: '1', text: 'Территория с льготным социально-экономическим статусом с 1949 по 1990 гг. - 1 МРП'},
          {value: '50%', text: 'Зона экологической катастрофы - 50%'},
          {value: '31%', text: 'Зона экологического кризиса - 31%'},
          {value: '20%', text: 'Зона экологического предкризисного состояния - 20%'}
        ],
        quarters: [
          {value: '0', text: 'Выберите квартал'},
          {value: '1', text: 'I квартал'},
          {value: '2', text: 'II квартал'},
          {value: '3', text: 'III квартал'},
          {value: '4', text: 'IV квартал'},
        ],
        halfyears: [
          {value: '0', text: 'Выберите полугодие'},
          {value: '1', text: 'I полугодие'},
          {value: '2', text: 'II полугодие'}
        ],
        years: [
          {value: '2024', text: '2024 год'},
          {value: '2023', text: '2023 год'},
          {value: '2022', text: '2022 год'},
          {value: '2021', text: '2021 год'},
          {value: '2020', text: '2020 год'},
          {value: '2019', text: '2019 год'},
          {value: '2018', text: '2018 год'},
        ],
        months: [
          {value: '0', text: 'Выберите месяц'},
          {value: '01', text: 'январь'},
          {value: '02', text: 'февраль'},
          {value: '03', text: 'март'},
          {value: '04', text: 'апрель'},
          {value: '05', text: 'май'},
          {value: '06', text: 'июнь'},
          {value: '07', text: 'июль'},
          {value: '08', text: 'август'},
          {value: '09', text: 'сентябрь'},
          {value: '10', text: 'октябрь'},
          {value: '11', text: 'ноябрь'},
          {value: '12', text: 'декабрь'},
        ],
        monthsquarters: [
          {value: '0', text: 'Выберите месяц или квартал'},
          {value: '01', text: 'январь'},
          {value: '02', text: 'февраль'},
          {value: '03', text: 'март'},
          {value: '1q', text: 'I квартал'},
          {value: '04', text: 'апрель'},
          {value: '05', text: 'май'},
          {value: '06', text: 'июнь'},
          {value: '2q', text: 'II квартал'},
          {value: '07', text: 'июль'},
          {value: '08', text: 'август'},
          {value: '09', text: 'сентябрь'},
          {value: '3q', text: 'III квартал'},
          {value: '10', text: 'октябрь'},
          {value: '11', text: 'ноябрь'},
          {value: '12', text: 'декабрь'},
          {value: '4q', text: 'IV квартал'}
        ],
        workweeks: [
          {value: '40_5', text: '40-часовая, пятидневка'},
          {value: '40_6', text: '40-часовая, шестидневка'},
          {value: '36_5', text: '36-часовая, пятидневка'},
          {value: '36_6', text: '36-часовая, шестидневка'}
        ],
        citizen: [
          {value: {id: 1, resident: 1, eaes_member: 1}, text: 'Гражданин Республики Казахстан'},
          {value: {id: 2, resident: 0, eaes_member: 1}, text: 'Не гражданин РК из страны ЕАЭС'},
          {value: {id: 3, resident: 1, eaes_member: 1}, text: 'Не гражданин РК из дальнего зарубежья с видом на жительство в РК'},
          {value: {id: 4, resident: 0, eaes_member: 0}, text: 'Не гражданин РК из дальнего зарубежья без вида на жительство в РК'},
        ]

      }

    }
  },
  methods: {
    Enum: function (type, name,) {
      switch (type) {
        case 'local':
          this.options = this.$store.state.enums[name];
          break;
        case 'enum':
          this.options = this.enums[name];
          break;

      }
      return this.options;
    }
  },
  computed: {
    model: {
      get() {
        return this.value;
      },
      set(val) {
        this.$emit('input', val);
      }
    }
  }

}
</script>
